import React, { useEffect, useRef } from "react";
import "./Ads.css";

function Ads() {
  const divEl = useRef(null);

  // const script = document.createElement("script");

  // script.src = "./Adstera300x250.js";
  // script.async = true;

  // document.body.appendChild(script);

  // return () => {
  //   document.body.removeChild(script);
  // };

  return <div className="_Ad_" ref={divEl}></div>;
}

export default Ads;
